module.exports = {
  CONTACT: "a9086a18-2db8-4e28-a6ea-210ef5dfe26c",
  SOURCE: "6f4c0e1f-adb9-48b7-8595-f71072a4f1ee",
  STATUS: "4d2598c9-24ad-4abd-b7ab-ca1aa2a34149",
  CREATED_AT: "created_at",
  CONFIRMATION_LAST_SENT_AT: "confirmation_last_sent_at",
  CREDENTIALS: "credentials_rollup"
};
